import { applyMiddleware, createStore, compose, combineReducers } from "redux";
import { i18nState } from "redux-i18n";
import createSagaMiddleware from "redux-saga";
import { all } from "redux-saga/effects";

import { emptyStore } from "redux/ws";
import wsReducers from "redux/ws/reducers";
import wsSagas from "redux/ws/sagas";

let composeFunc = compose;
const createdStores = {};

// Always include our default sagas
const allSagas = (sagas) =>
    function* runAllSagas() {
        yield all([wsSagas(), sagas ? sagas() : null]);
    };

function createNewStore(store, state) {
    const { getInitialState = (x) => x, reducers, middleware: middlewares = [], sagas } = store;

    const middleware = middlewares.slice();

    if (__DEV__) {
        /* eslint-disable */

        const disable = Number(localStorage.DISABLE_REDUX_DEVTOOLS || 0);
        if (!disable) {
            // We do some denormalization on retain survey pages that cause
            // major slowdowns if we use this plugin there :(
            if (store.name !== "pulse") {
                middleware.unshift(require("redux-immutable-state-invariant").default());
            }
            composeFunc = require("@redux-devtools/extension").composeWithDevTools;
        }
        window.__REDUX_STORES = createdStores;
        /* eslint-enable */
    }

    const sagaMiddleware = createSagaMiddleware();

    const newStore = createStore(
        combineReducers({
            ...reducers,
            i18nState,
            ws: wsReducers,
        }),
        getInitialState(state),
        composeFunc(applyMiddleware(...middleware.concat([sagaMiddleware]))),
    );

    sagaMiddleware.run(allSagas(sagas));

    return newStore;
}

export default (store, state = {}) => {
    if (!store) {
        store = emptyStore; // eslint-disable-line no-param-reassign
    }

    if (!createdStores[store.name]) {
        createdStores[store.name] = createNewStore(store, state);
    }

    return createdStores[store.name];
};
